import { useState } from 'react';
import MainFiltersItem from './MainFiltersItem';
import useFiltersQueryParams from 'hooks/useFiltersQueryParams';
import { useSelector } from 'react-redux';

const MainFilters = ({ parentSwiper, filters, setOffsetCount }) => {
  const [activeFilter, setActiveFilter] = useState(null);
  const { data } = filters;
  const { searchParams, setQueryParam, deleteQueryParam, clearQueryParams } = useFiltersQueryParams();
  const {isMobileFiltersOpened} = useSelector((state) => state.popups);
  const {totalCount} = useSelector((state) => state.cards);

  const handleCheckboxChange = (event) => {
    const { name, checked, value } = event.target;
    const selectedValues = searchParams.get(name) ? searchParams.get(name).split(',') : [];
    if (checked) {
      if (!selectedValues.includes(value) && event.target.type === 'checkbox') {
        setQueryParam(name, [...selectedValues, value].join(','));
      } else if(!selectedValues.includes(value) && event.target.type === 'radio') {
        setQueryParam(name, value);
      }
    } else {
      const updatedValues = selectedValues.filter((val) => val !== value);
      if (updatedValues.length > 0) {
        setQueryParam(name, updatedValues.join(','));
      } else {
        deleteQueryParam(name);
      }
    }

    setOffsetCount(0)
  };


  if (!data) return null;

  return (
    <>
    <div className={`main-content__filters  ${isMobileFiltersOpened ? 'opened' : ''}`}>
      <p className="main-content__filters-title">
        Filters
        <span>{totalCount}</span>
      </p>
      <section className="main-content__filters-list">
        {data.map((filter) => (
          filter.filter !== null && (
            <MainFiltersItem
              key={filter.name}
              parentSwiper={parentSwiper}
              activeFilter={activeFilter}
              setActiveFilter={setActiveFilter}
              category={filter.name}
              queryValue={filter.value}
              filters={filter.filter}
              searchParams={searchParams}
              handleCheckboxChange={handleCheckboxChange}
              clearQueryParams={clearQueryParams}
            />
          )
        ))}
      </section>
    </div>
    </>
  );
};

export default MainFilters;
